import { useProjectModelError } from "@planzone/dto";
import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ projectModel, project, zone, configuration }) =>
    present(
      repository
        .duplicateProjectFromModel(projectModel, project, zone)
        .then((p) =>
          repository.updateProjectConfiguration(p, configuration).then(() => ({
            project: { ...p, portfolios: project.portfolios },
            projectModel,
            configuration,
            zone,
          })),
        )
        .catch((error) =>
          Promise.reject({
            error: { ...useProjectModelError, ...error },
            zone,
            project,
            projectModel,
            configuration,
          }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
